import * as React from 'react'
import { connect } from 'react-redux'
import {
    AddCatgrs, fetchCatgrys,
    fetchCatgryById
} from './action'
import Category from '../../screens/Settings/Category'

class CategoryContainer extends React.Component<Props, State>{
    render() {
        return <Category AddCatgrs={this.props.AddCatgrs}
            fetchCatgrys={this.props.fetchCatgrys}
            CategorysList={this.props.CategorysList}
            fetchCatgryById={this.props.fetchCatgryById} />
    }
}
function bindAction(dispatch) {
    return {
        AddCatgrs: value => {
            // console.log("action", value)
            dispatch(AddCatgrs(value));
        },
        fetchCatgrys: () => {
            dispatch(fetchCatgrys());
        },
        fetchCatgryById: item => {
            dispatch(fetchCatgryById(item));
        }

    }
}
function mapStateToProps(state) {

    return {
        CategorysList: state.CategoryReducer.CategorysList
    }
}

export default connect(mapStateToProps, bindAction)(CategoryContainer)